import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OperatorDailyStatsQuery } from '@/gql/graphql';

export const fetchOperatorDailyStats = async (operatorId: string): Promise<OperatorDailyStatsQuery['operatorDailyStats'] | null> => {
  const response = await queryExecute({
    query: graphql(`
      query OperatorDailyStats($operatorId: String!) {
        operatorDailyStats(operatorId: $operatorId) {
          date
          regCalls
          hardRegistrations
          trialStarts
          totalCalls
        }
      }
    `),
    variables: {
      operatorId,
    },
    fetchPolicy: 'no-cache',
  });

  return (response as any).data.operatorDailyStats ?? null;
};
